import apiClient from "../config/apiClient";

const authHeaders = () => ({
  headers: {
    Authorization: "Bearer " + window.localStorage.getItem("token"),
  },
});

export const fetchPatientAddresses = async (patientId) => {
  return await apiClient.get(
    `/public/portal?url=patient/${patientId}/addresses`,
    authHeaders()
  );
};

export const savePatientAddress = async (patientId, data) => {
  return await apiClient.post(
    `/public/portal?url=patient/${patientId}/addresses`,
    data,
    authHeaders()
  );
};

export const updatePatientAddress = async (addressId, data) => {
  return await apiClient.put(
    `/public/portal?url=patient/addresses/${addressId}`,
    data,
    authHeaders()
  );
};

export const deletePatientAddress = async (addressId) => {
  return await apiClient.delete(
    `/public/portal?url=patient/addresses/${addressId}`,
    authHeaders()
  );
};

export const setDefaultPatientAddress = async (addressId) => {
  return await apiClient.patch(
    `/public/portal?url=patient/addresses/${addressId}/default`,
    {},
    authHeaders()
  );
};

export const fetchDeliveryZones = async () => {
  return await apiClient.get(
    `/public/portal?url=patient/delivery-zones`,
    authHeaders()
  );
};
